const {trackAddToCart} = require('./../..//ecommerceGTag');
$(function () {
    if ($('#service-booking-page').length === 0) {
        return;
    }

    $(window).on('beforeunload', function () {
        let urlParams = new URLSearchParams(window.location.search);
        let dateTimestamp = urlParams.get('d');

        const preferredDate = {
            value: dateTimestamp,
            expiry: new Date().getTime() + 4000 // 4 seconds
        }
        localStorage.setItem('preferredDate', JSON.stringify(preferredDate));
    });

    $('#bookingForm').on('submit', function (e) {
        e.preventDefault();
        let names = [];
        $('#nameFields .namesRow').each(function (index) {
            let name = $(this).find('input[name^="names[' + index + ']"][name$="][\'firstname\']"]').val();
            let surname = $(this).find('input[name^="names[' + index + ']"][name$="][\'surname\']"]').val();

            names.push({
                name: name, surname: surname
            });
        });

        let requestData = {
            action: 'add-to-cart', formData: {
                hash: $('#hash').val(),
                hotel_name: $('#hotel_name').val(),
                pickup_time: $('#pickup_time').val(),
                guided_service_id: getGuidedServiceId().guidedServiceId,
                guided2_service_id: getGuidedServiceId().guided2ServiceId,
                location_id: $('input[name="location"]:checked').val(),
                extra_luggage: $('#extra_luggage').prop('checked'),
                child_seat: $('#child_seat').prop('checked'),
                comments: $('#comments').val(),
                flight_number: $('#flight_number').val(),
                flying_from: $('#flying_from').val(),
                arrival_date: $('#arrival_date').val(),
                arrival_time: $('#arrival_time').val(),
                destination_hotel_name: $('#destination_hotel_name').val(),
                return_date: $('#return_date').val(),
                return_pickup_time: $('#return_pickup_time').val(),
                return_hotel_name: $('#return_hotel_name').val(),
                boosters_count: $('#boosters_count').val(),
                child_seats_count: $('#child_seats_count').val(),
                infant_seats_count: $('#infant_seats_count').val(),
                names: names,
            }
        }

        $.ajax({
            url: '/wp-admin/admin-ajax.php',
            type: 'POST',
            data: requestData,
            dataType: 'JSON',
            beforeSend: function () {
                $('#bookingForm .form-summary .form-summary--button .fa-spinner').removeClass('d-none').show();
                $('#bookingForm .form-summary .form-summary--button .button-text').hide();
                $('#bookingForm .form-summary .form-summary--button').addClass('disabled');
            },
            success: function (response) {
                trackAddToCart(response.order_added_to_backet);
                if (response.success == true) {
                    let slug = 'cart';

                    switch (currentPageLanguage) {
                        case 'en':
                            slug = 'cart';
                            break;
                        case 'es':
                            slug = 'carrito';
                            break;
                        case 'de':
                            slug = 'einkaufswagen';
                            break;
                        case 'pl':
                            slug = 'koszyk';
                            break;
                        case 'fr':
                            slug = 'panier';
                            break;
                        case 'it':
                            slug = 'carrello';
                            break;
                    }

                    window.location.href = '/' + slug;
                }
                if (response.success == false) {


                    let keysInputsMap = {
                        'from': 'hotel_name',
                        'pickup_time': 'pickup_time',
                        'location': 'location',
                        'arrival_date': 'arrival_date',
                        'arrival_time': 'arrival_time',
                        'destination_hotel_name': 'destination_hotel_name',
                        'return_date': 'return_date',
                        'return_pickup_time': 'return_pickup_time',
                        'return_hotel_name': 'return_hotel_name',
                        'boosters_count': 'boosters_count',
                        'child_seats_count': 'child_seats_count',
                        'infant_seats_count': 'infant_seats_count',
                    }

                    $.each(response.errors, function (key, value) {
                        let errorElement = $('<div class="form-error-box">' + value + '</div>');
                        //if exist key in map
                        if (keysInputsMap[key] !== undefined) {
                            let inputElement = $('#bookingForm').find('input[name="' + keysInputsMap[key] + '"]');
                            inputElement.after(errorElement);
                            inputElement.addClass('is-invalid');
                        } else {
                            $('#form-error-row').removeClass('d-none').show();
                            $('#form-error-row .form-error .form-error--message').html(response.message);
                            $('html, body').animate({
                                scrollTop: $('#form-error-row').offset().top - 150
                            }, 500)
                            $('#form-error-row').delay(6000).fadeOut(1000, function () {
                                $(this).addClass('d-none');
                            });
                        }
                    });

                    $('#bookingForm input').on('focus', function () {
                        $(this).removeClass('is-invalid');
                        $(this).next().remove();
                    });

                    $('#bookingForm .form-summary .form-summary--button .fa-spinner').addClass('d-none').hide();
                    $('#bookingForm .form-summary .form-summary--button .button-text').show();
                    $('#bookingForm .form-summary .form-summary--button').removeClass('disabled');
                }
            },
        });
    });

    function getGuidedServiceId() {
        let selectedPickUpOption = $('#pickup_time').find('option:selected');

        let guidedServiceId = selectedPickUpOption.data('guided_service_id');
        let guided2ServiceId = selectedPickUpOption.data('guided2_service_id');

        return {
            guidedServiceId: guidedServiceId, guided2ServiceId: guided2ServiceId
        }
    }
});

